import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: true,
  documents: null,
  error: "",
};

const documentsSlice = createSlice({
  name: "documentsSlice",
  initialState: initialState,
  reducers: {
    setState(state, action) {
      state.loading = action.payload.loading;
      state.error = action.payload.error;
      state.documents = action.payload.documents;
    },
  },
});

export const documentsActions = documentsSlice.actions;

export default documentsSlice.reducer;
